// extracted by mini-css-extract-plugin
module.exports = {"main":"guideline-page_main__3Xked"};